$(document).on('turbo:load', function() {

  $('#add-new-location-button').on('click', function(e) {
      e.preventDefault();
    // Make a copy of the first territory column
    let newTh = $('#table-head .select-territory-header').first().clone();
    let newTd = $('.include-brand-toggle').first().clone();
    // Reset the input value; the place-autocomplete controller re-reconciles the rest.
    newTh.find('.territory_area').val('');
    newTd.find("input[type='checkbox']").prop('checked', true);
    newTd.find('.negative').hide();
    newTd.find('.affirmative').show();
    // Add a new column before the Add New Location column
    $('#table-head tr .add-new-location').before(newTh);
    $('.brand-row .territory-check-count').before(newTd)
    $('.add-brand-row').append('<td>')
    // Update the location cell of each row with the number of Yes's
    $('.brand-row').each(function() {
      updateLocationSelectedCount($(this))
    });
    updateRemoveButtons();
    updateSendTerritoryCheckButton();
    $('[data-bs-toggle="tooltip"]').tooltip();
  });

  $('#add-brands-button').on('click', function(e) {
    e.preventDefault();
    // Make a copy of the first brand row
    let brandRow = $('.brand-row').first().clone();
    brandRow.find("input[type='checkbox']").prop('checked', true)
    brandRow.find('select.select-brand').val(null);

    updateIncludeBrandCell(brandRow.find("input[type='checkbox']"))
    updateLocationSelectedCount(brandRow)

    $('#table-body .add-brand-row').before(brandRow);
    updateRemoveButtons();
    updateSendTerritoryCheckButton()
  });

  let tableBody = $('#table-body')
  tableBody.delegate('.include-brand-toggle', 'click', function() {
    let checkbox = $(this).find("input[type='checkbox']")
    if (checkbox.is(':checked')) {
      checkbox.prop('checked', false)
    }
    else {
      checkbox.prop('checked', true)
    }
    // Toggle include-brand cells
    updateIncludeBrandCell(checkbox)

    updateLocationSelectedCount($(this).closest('.brand-row'))
    updateSendTerritoryCheckButton()
  });

  $('#territory-check-table').delegate('.remove-brand-js', 'click', function(e) {
    e.preventDefault();
    if ($('.brand-row').length < 2) return;

    $(this).closest('.brand-row').remove();
    updateRemoveButtons();
    updateSendTerritoryCheckButton();
  });

  $('#territory-check-table').delegate('.remove-location-js', 'click', function(e) {
    e.preventDefault();
    if ($('.location-col').length < 2) return;

    const th = $(this).closest('.location-col');
    const index = th.index();
    $(this).closest('table').find('tr').each(function() {
      $(this).children('td:eq('+index+')').remove();
    });
    th.remove();
    updateRemoveButtons();
    $('.brand-row').each(function() {
      updateLocationSelectedCount($(this))
    });
    updateSendTerritoryCheckButton();
  });

  updateRemoveButtons();
  updateSendTerritoryCheckButton();

  // Disable the Enter key from submitting form
  $('.territory-check-page').on("keydown", "form:not([data-controller~='territory-check-response'])", function(event) {
    return event.key !== "Enter";
  });

  // Helper Functions
  //

  function updateIncludeBrandCell(checkboxes) {
    checkboxes.each(function() {
      $(this).closest('td').find('.affirmative').toggle($(this).is(':checked'))
      $(this).closest('td').find('.negative').toggle(!$(this).is(':checked'))
    });
  }

  // One location and one brand are the minimums, so the last of each offers no way to remove
  // itself - hiding the button beats an alert that only tells the user afterwards.
  function updateRemoveButtons() {
    $('.remove-location-js').toggle($('.location-col').length > 1)
    $('.remove-brand-js').toggle($('.brand-row').length > 1)
  }

  function updateLocationSelectedCount(brandRow) {
    let checkBoxes = $(brandRow).find('.include-brand')
    let count = 0

    checkBoxes.each(function() {
      if ($(this).is(':checked')) {
        count++;
      }
    });

    const label = count === 1 ? ' Location Selected' : ' Locations Selected'
    $(brandRow).find('.territory-check-count').text(count + label)
  }

  // One check is sent per brand with at least one Yes, so the button counts those
  // brands - not rows - and has nothing to send when every cell is No.
  function updateSendTerritoryCheckButton() {
    const count = $('#table-body .brand-row').filter(function() {
      return $(this).find('.include-brand:checked').length > 0
    }).length

    const label = count === 1 ? ' Territory Check' : ' Territory Checks'
    $('#submit-button').prop('value', 'Send ' + count + label).prop('disabled', count === 0)
  }

  $('.brand-territory-check-info-modal-js').click(function() {
    $.get(`${$(this).attr('path')}`).done(function(html) {
      const myModal = $('#brand-territory-check-info-modal')
      myModal.find('.modal-body').html(html)
      myModal.modal('show');
    });
  });

  const searchFilter = $('.territory-check-page .search-field')

  searchFilter.on('keydown', function(e) {
    if (e.key === 'Enter') {
      e.preventDefault(); // Prevents default action
      $(this).closest('form').submit(); // Submits form to search t checks after enter is hit
    }
  })

});
